<div class="game-dashboard-block statistics-line-chart-block">
  <div class="statistics-line-chart-block__headline">
    <brt-dashboard-boxes-head [data]="data.headlineBlockData"></brt-dashboard-boxes-head>
  </div>

  <div class="statistics-line-chart-block__content">
    <div class="statistics-line-chart-block__chart-headline">
      <div class="statistics-line-chart-block__chart-categories">
        <div class="statistics-line-chart-block__chart-category" *ngFor="let category of data.categories" (click)="setCategory(category)">
          <span class="statistics-line-chart-block__chart-category-icon"><brt-icon [icon]="category.icon"></brt-icon></span>
          <span class="statistics-line-chart-block__chart-category-label">{{category.label}}</span>
        </div>
      </div>

      <div class="statistics-line-chart-block__chart-legend">
        <div class="statistics-line-chart-block__chart-legend-item" *ngFor="let legendItem of currentCategory.datasets">
          <div class="statistics-line-chart-block__chart-legend-item-circle" [ngStyle]="{'background-color': legendItem.color}"></div>
          <div class="statistics-line-chart-block__chart-legend-item-label">{{legendItem.label}}</div>
        </div>
      </div>
    </div>

    <div class="statistics-line-chart-block__chart-wrapper">
      <brt-chart [data]="chartComponentData"></brt-chart>
    </div>
  </div>
</div>
